import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class JoinSocietyService {
private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) {}

   joinSociety(payload:any): Observable<any> {
    return this.http.post(`${this.baseUrl}/join_society`, payload);
  }

   fetchBlocks(account_id: number): Observable<any[]> {
    return this.http.post<any[]>(`${this.baseUrl}/block_dropdown`, { account_id });
  }

   fetchSociety(): Observable<any[]> {
      return this.http.get<any[]>(`${this.baseUrl}/account_dropdown`);
    }


// Fetch Floors
fetchFloors(account_id: number): Observable<any[]> {
  return this.http.post<any[]>(`${this.baseUrl}/fetch_floor_dropdown`, { account_id });
}

  // Fetch Units
  fetchUnits(account_id: number, block_id?: number | null, phase_id?: number | null, floor_id?: number | null, unit_type?: string | null): Observable<any[]> {
    const payload = {
      account_id: String(account_id),
      block_id: block_id ?? null,
      phase_id: phase_id ?? null,
      floor_id: floor_id ?? null,
      unit_type: unit_type ?? null
    };
    return this.http.post<any[]>(`${this.baseUrl}/unit_dropdown`, payload);
  }

  // Fetch Phases
  fetchPhases(account_id: number): Observable<any[]> {
    return this.http.post<any[]>(`${this.baseUrl}/fetch_phase_dropdown`, { account_id });
  }

  // Fetch Wings
  fetchWings(phase_id: number, account_id: number): Observable<any[]> {
    return this.http.post<any[]>(`${this.baseUrl}/block_dropdown`, { phase_id, account_id });
  }
}
